import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import {Icon, IconButton, makeStyles, Tooltip} from "@material-ui/core";
import {Loading} from "../../../../Utils/Loading/Loading";
import {useDispatch, useSelector} from "react-redux";
import {toggleTreeDrawer} from "../../reducers/applicationBuilder.slice";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(5) + 1,
        },
    },
    barArea: {
        width: theme.spacing(6) + 1,
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'center',
        paddingTop: 10
    }
}))
const TreeContainer = ({children}) => {
    const isFetching = useSelector(state => state.applicationBuilder.isFetching)
    const open = useSelector(state => state.applicationBuilder.isOpenedTreeDrawer)
    const dispatch = useDispatch();
    const classes = useStyles();
    return (
        <Drawer open={open} variant={"permanent"}
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
                PaperProps={{style: {position: 'absolute'}}}
                BackdropProps={{style: {position: 'absolute'}}}
                ModalProps={{
                    container: document.getElementById('drawer-container'),
                    style: {position: 'absolute'}
                }}
        >
            <div style={{
                position: 'absolute',
                display: 'flex',
                width: open ? drawerWidth - 1 : 'auto',
                overflowX: 'hidden',
                height: '100%'
            }}>
                <div className={classes.barArea}>
                    <Tooltip title={'Applications'}>
                        <IconButton
                            size={'small'}
                        >
                            <Icon>
                                apps
                            </Icon>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Tree'}>
                        <IconButton
                            size={'small'}
                            onClick={() => dispatch(toggleTreeDrawer())}
                            style={{marginTop: 10}}
                        >
                            <Icon>
                                account_tree
                            </Icon>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Application Export'}>
                        <IconButton
                            size={'small'}
                            onClick={() => dispatch(toggleTreeDrawer())}
                            style={{marginTop: 10}}
                        >
                            <Icon>
                                ios_share
                            </Icon>
                        </IconButton>
                    </Tooltip>
                </div>
                <div
                    style={{
                    width: '100%',
                    height: '100%'
                }}
                >
                    {children}
                </div>
            </div>
            {isFetching && (
                <Loading/>
            )}
        </Drawer>
    )
}
export default TreeContainer;